export default "__VITE_ASSET__DC7k1HIT__"